import { createContext, useContext } from 'react';

export type VndRequestsFiltersValue = {
  statusFilter: string;
  dateRange: { from: Date | null; to: Date | null };
  searchQuery: string;
  profileId: string;
};

export const VndRequestsFiltersContext = createContext<VndRequestsFiltersValue | null>(null);

export function useVndRequestsFilters(): VndRequestsFiltersValue {
  const v = useContext(VndRequestsFiltersContext);
  if (!v) {
    throw new Error('useVndRequestsFilters используется только на странице заявок');
  }
  return v;
}
